import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["element", "button"]
    static classes = ["hidden"]

    declare readonly elementTargets: HTMLElement[]
    declare readonly buttonTargets: HTMLElement[]
    declare readonly hiddenClass: string

    toggle() {
        // Ensure the class is actually defined in your HTML before trying to use it
        const className = this.hiddenClass

        this.elementTargets.forEach((el) => {
            el.classList.toggle(className)
        })

        this.buttonTargets.forEach((btn) => {
            btn.classList.toggle(className)
        })
    }
}
